import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import MessagesContentWindows from '@/components/common/userNotifications/components/OS/messagesContent.windows.vue';
import MessagesContentLinux from '@/components/common/userNotifications/components/OS/messagesContent.linux.vue';
import { useOsService } from '@/services/OsService/OsService';


export default /*#__PURE__*/_defineComponent({
  __name: 'messages-content',
  setup(__props) {

const osService = useOsService();

return (_ctx: any,_cache: any) => {
  return (_unref(osService)?.isWindows.value)
    ? (_openBlock(), _createBlock(MessagesContentWindows, { key: 0 }))
    : (_unref(osService)?.isUnix.value)
      ? (_openBlock(), _createBlock(MessagesContentLinux, { key: 1 }))
      : _createCommentVNode("", true)
}
}

})